/**
 * Constants for tab panel names used across the application
 * This ensures consistency and makes it easy to change tab names in one place
 */
export const TAB_NAMES = {
  HOW_TO_USE: 'howToUse',
  FAQ: 'faq',
  CONTACT: 'contact',
} as const;

/**
 * Type for tab names to ensure type safety
 */
export type TabName = (typeof TAB_NAMES)[keyof typeof TAB_NAMES];
